import { render } from "./check-circle.svg?vue&type=template&id=47a0e844?inline"
const script = {}
script.render = render

export default script